/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayName: NonNullable<unknown>, product: NonNullable<unknown> }} Wide_Great_Finch_HumInputs */

const en_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`You've already purchased ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`You're already subscribed to ${i?.displayName}!`)
	
};

const id_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Anda telah membeli ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`Anda sudah berlangganan ${i?.displayName}!`)
	
};

const ms_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Anda telah pun membeli ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`Anda telah pun melanggan ${i?.displayName}!`)
	
};

const ca_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Ja has comprat ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`Ja estàs subscrit a ${i?.displayName}!`)
	
};

const cs_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Již jste si zakoupili ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`Již máte předplatné ${i?.displayName}!`)
	
};

const da_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Du har allerede købt ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`Du abonnerer allerede på ${i?.displayName}!`)
	
};

const de_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Du hast ${i?.displayName} bereits gekauft.`);
	return /** @type {LocalizedString} */ (`Du hast ${i?.displayName} bereits abonniert!`)
	
};

const et_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Oled juba ostnud ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`Oled juba tellinud ${i?.displayName}!`)
	
};

const es_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Ya compraste ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`¡Ya estás suscrito a ${i?.displayName}!`)
	
};

const fr_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Vous avez déjà acheté ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`Vous êtes déjà abonné à ${i?.displayName} !`)
	
};

const hr_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Već ste kupili ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`Već ste pretplaćeni na ${i?.displayName}!`)
	
};

const it_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Hai già acquistato ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`Sei già abbonato a ${i?.displayName}!`)
	
};

const lv_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Jūs jau esat iegādājies ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`Jūs jau esat abonējis ${i?.displayName}!`)
	
};

const lt_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Jūs jau įsigijote ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`Jūs jau esate prenumeravę ${i?.displayName}!`)
	
};

const hu_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Már megvásároltad a ${i?.displayName} terméket.`);
	return /** @type {LocalizedString} */ (`Már előfizettél a ${i?.displayName} szolgáltatásra!`)
	
};

const nl_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Je hebt ${i?.displayName} al gekocht.`);
	return /** @type {LocalizedString} */ (`Je bent al geabonneerd op ${i?.displayName}!`)
	
};

const nb_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Du har allerede kjøpt ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`Du abonnerer allerede på ${i?.displayName}!`)
	
};

const pl_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Już zakupiłeś ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`Masz już subskrypcję ${i?.displayName}!`)
	
};

const pt_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Você já comprou o ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`Você já está inscrito no ${i?.displayName}!`)
	
};

const ro_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Ai achiziționat deja ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`Ești deja abonat la ${i?.displayName}!`)
	
};

const sk_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`${i?.displayName} ste si už zakúpili.`);
	return /** @type {LocalizedString} */ (`${i?.displayName} už máte predplatené!`)
	
};

const sl_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`${i?.displayName} ste že kupili.`);
	return /** @type {LocalizedString} */ (`Že ste naročeni na ${i?.displayName}!`)
	
};

const fi_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Olet jo ostanut tuotteen ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`Olet jo tilannut tuotteen ${i?.displayName}!`)
	
};

const sv_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Du har redan köpt ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`Du prenumererar redan på ${i?.displayName}!`)
	
};

const vi_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Bạn đã mua ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`Bạn đã đăng ký ${i?.displayName}!`)
	
};

const tr_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`${i?.displayName} ürününü zaten satın aldınız.`);
	return /** @type {LocalizedString} */ (`Zaten ${i?.displayName} aboneliğiniz var!`)
	
};

const el_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Έχετε ήδη αγοράσει το ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`Είστε ήδη συνδρομητής στο ${i?.displayName}!`)
	
};

const bg_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Вече сте закупили ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`Вече сте абонирани за ${i?.displayName}!`)
	
};

const ru_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Вы уже приобрели ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`Вы уже подписаны на ${i?.displayName}!`)
	
};

const sr_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Већ сте купили ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`Већ сте претплаћени на ${i?.displayName}!`)
	
};

const uk_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Ви вже придбали ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`Ви вже підписані на ${i?.displayName}!`)
	
};

const ka_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`თქვენ უკვე შეიძინეთ ${i?.displayName}.`);
	return /** @type {LocalizedString} */ (`თქვენ უკვე გამოწერილი გაქვთ ${i?.displayName}!`)
	
};

const hi_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`आपने पहले ही ${i?.displayName} खरीद लिया है।`);
	return /** @type {LocalizedString} */ (`आप पहले से ही ${i?.displayName} की सदस्यता ले चुके हैं!`)
	
};

const th_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`คุณได้ซื้อ ${i?.displayName} ไปแล้ว`);
	return /** @type {LocalizedString} */ (`คุณได้สมัครสมาชิก ${i?.displayName} อยู่แล้ว!`)
	
};

const ko_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`이미 ${i?.displayName}을 구매하셨습니다.`);
	return /** @type {LocalizedString} */ (`이미 ${i?.displayName}을 구독 중이십니다!`)
	
};

const zh_tw_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`您已購買 ${i?.displayName}。`);
	return /** @type {LocalizedString} */ (`您已訂閱 ${i?.displayName}！`)
	
};

const ja_wide_great_finch_hum = /** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`既に ${i?.displayName} を購入済みです。`);
	return /** @type {LocalizedString} */ (`既に ${i?.displayName} に登録されています！`)
	
};

/** @type {(inputs: Wide_Great_Finch_HumInputs) => LocalizedString} */
const zh_wide_great_finch_hum = en_wide_great_finch_hum;

/**
* | product | output |
* | --- | --- |
* | "origin" | "You've already purchased {displayName}." |
* | * | "You're already subscribed to {displayName}!" |
*
* @param {Wide_Great_Finch_HumInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const wide_great_finch_hum = /** @type {((inputs: Wide_Great_Finch_HumInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wide_Great_Finch_HumInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_wide_great_finch_hum(inputs)
	if (locale === "ms") return ms_wide_great_finch_hum(inputs)
	if (locale === "ca") return ca_wide_great_finch_hum(inputs)
	if (locale === "cs") return cs_wide_great_finch_hum(inputs)
	if (locale === "da") return da_wide_great_finch_hum(inputs)
	if (locale === "de") return de_wide_great_finch_hum(inputs)
	if (locale === "et") return et_wide_great_finch_hum(inputs)
	if (locale === "es") return es_wide_great_finch_hum(inputs)
	if (locale === "fr") return fr_wide_great_finch_hum(inputs)
	if (locale === "hr") return hr_wide_great_finch_hum(inputs)
	if (locale === "it") return it_wide_great_finch_hum(inputs)
	if (locale === "lv") return lv_wide_great_finch_hum(inputs)
	if (locale === "lt") return lt_wide_great_finch_hum(inputs)
	if (locale === "hu") return hu_wide_great_finch_hum(inputs)
	if (locale === "nl") return nl_wide_great_finch_hum(inputs)
	if (locale === "nb") return nb_wide_great_finch_hum(inputs)
	if (locale === "pl") return pl_wide_great_finch_hum(inputs)
	if (locale === "pt") return pt_wide_great_finch_hum(inputs)
	if (locale === "ro") return ro_wide_great_finch_hum(inputs)
	if (locale === "sk") return sk_wide_great_finch_hum(inputs)
	if (locale === "sl") return sl_wide_great_finch_hum(inputs)
	if (locale === "fi") return fi_wide_great_finch_hum(inputs)
	if (locale === "sv") return sv_wide_great_finch_hum(inputs)
	if (locale === "vi") return vi_wide_great_finch_hum(inputs)
	if (locale === "tr") return tr_wide_great_finch_hum(inputs)
	if (locale === "el") return el_wide_great_finch_hum(inputs)
	if (locale === "bg") return bg_wide_great_finch_hum(inputs)
	if (locale === "ru") return ru_wide_great_finch_hum(inputs)
	if (locale === "sr") return sr_wide_great_finch_hum(inputs)
	if (locale === "uk") return uk_wide_great_finch_hum(inputs)
	if (locale === "ka") return ka_wide_great_finch_hum(inputs)
	if (locale === "hi") return hi_wide_great_finch_hum(inputs)
	if (locale === "th") return th_wide_great_finch_hum(inputs)
	if (locale === "ko") return ko_wide_great_finch_hum(inputs)
	if (locale === "zh") return zh_wide_great_finch_hum(inputs)
	if (locale === "zh-tw") return zh_tw_wide_great_finch_hum(inputs)
	if (locale === "ja") return ja_wide_great_finch_hum(inputs)
	return en_wide_great_finch_hum(inputs)
});